import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { getDirectLoggedIn, RedirectService } from '@uxdf/direct-shared-lib';

@Injectable()
export class GuestGuard implements CanActivate {
  constructor(
    private readonly store: Store<any>,
    private readonly router: Router,
    private readonly redirectService: RedirectService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    // customer should be redirected to home in case he later logs in on guest pages
    if (!this.redirectService.redirect) {
      this.redirectService.redirect = '/home';
    }

    return this.store.pipe(
      select(getDirectLoggedIn),
      take(1),
      map(loggedIn => {
        if (!loggedIn) {
          return true;
        }
        console.warn('[GUEST GUARD]');
        return this.router.createUrlTree(['/home']);
      })
    );
  }
}
